import { Component } from '@angular/core';
import { DndDropEvent } from 'ngx-drag-drop';
import { FiDocumentTemplateLayoutTrashBinService } from '@fi-app/document-template/document-template-layout-trash-bin.service';

@Component({
    selector: 'fi-document-template-trash-bin',
    template: `<ul [dndDropzone]="['control', 'widget']" class="drop-dnd-list" (dndDrop)="trashDrop($event)"></ul>`,
    standalone: false,
})
export class FiDocumentTemplateTrashBinComponent {
    constructor(private documentTemplateLayoutTrashBinService: FiDocumentTemplateLayoutTrashBinService) {}

    trashDrop(event: DndDropEvent) {
        this.documentTemplateLayoutTrashBinService.dropItem = true;
    }
}
